// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"32cd6a6e","538":"a646e7a8","566":"47d2bd50","614":"23ef11ca","626":"88857501","947":"9ba0fdbb"}[chunkId] + ".chunk.js";
};